var map = {
	"./social-500px.svg": 141,
	"./social-dribbble.svg": 142,
	"./social-facebook.svg": 143,
	"./social-github.svg": 144,
	"./social-google.svg": 145,
	"./social-instagram.svg": 146,
	"./social-odnoklassniki.svg": 147,
	"./social-reddit.svg": 148,
	"./social-stackoverflow.svg": 149,
	"./social-steam.svg": 150,
	"./social-twitch.svg": 151,
	"./social-twitter.svg": 152,
	"./social-vkontakte.svg": 153,
	"./social-windows.svg": 154,
	"./social-yahoo.svg": 155
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth ^\.\/social\-.*\.svg$
// module id = 140
// module chunks = 0